import React from 'react';

import { Link, useLocation } from 'react-router-dom';
import { accessor } from '../../helpers';

export const HeaderNav = ({user}) => {

    const ordersAccess = accessor.orders(user);
    const officeAccess = accessor.office(user) || accessor.handOver(user);
    const advertAccess = accessor.advertAccess(user);
    const userInteractAccess = accessor.usersInteract(user);

    const location = useLocation();
    const curPath = location.pathname;

    return (
        <nav className="header__nav">
            {ordersAccess && <Link to="/orders" className={`header__nav-item ${curPath === '/orders' ? 'active' : ''}`}>
                Заказы
            </Link>}
            {userInteractAccess && <Link to="/stats" className={`header__nav-item ${curPath === '/stats' ? 'active' : ''}`}>
                Статистика
            </Link>}
            {officeAccess && <Link to="/office" className={`header__nav-item ${curPath === '/office' ? 'active' : ''}`}>
                Касса
            </Link>}
            {advertAccess && <Link to="/advert" className={`header__nav-item ${curPath.startsWith('/advert') ? 'active' : ''}`}>Реклама</Link>}
            <Link to="/settings" className={`header__nav-item ${curPath.startsWith('/settings') ? 'active' : ''}`}>
                Настройки
            </Link>
        </nav>
    );
};
